import * as React from "react";
import styled from "styled-components";
import { DefaultButtonWithTooltip } from "Components/Shared/Buttons/DefaultButtonWithTooltip";
import { DetailIcon } from "Components/Shared/Icons/DetailIcon";
import { UnstyledLink } from "Components/Shared/Routes/UnstyledLink";
import { useResource, Resources } from "Translations/Resources";

type Props = {
  url: string;
};

const StyledDetail = styled.div`
  svg {
    width: 22px;
    height: auto;
  }
`;

export const DetailColumn: React.FunctionComponent<Props> = props => {
  const { url } = props;
  const { t } = useResource();

  return (
    <StyledDetail>
      <UnstyledLink to={url}>
        <DefaultButtonWithTooltip
          title={t(Resources.Common.Column.Detail.Tooltip)}
        >
          <DetailIcon />
        </DefaultButtonWithTooltip>
      </UnstyledLink>
    </StyledDetail>
  );
};
